import styles from "./styles.module.css";
import { useRef } from "react";
import { MdDragHandle, MdChevronRight } from "react-icons/md";
import { useDrag, useDrop } from "react-dnd";
export default function Card({ utility, onClick, selected, index, onDrop }) {
  const cardRef = useRef();
  const [{ dragging }, dragRef] = useDrag({
    item: {
      type: "utility",
      index: index,
    },
    collect: (monitor, props) => ({
      dragging: monitor.isDragging(),
    }),
  });

  const [{ hovered }, dropRef] = useDrop({
    accept: "utility",
    drop: (...args) => handleDrop(...args),
    collect: (monitor) => ({
      hovered: !!monitor.isOver() && monitor.getItem().index !== index,
    }),
  });

  const handleDrop = (item) => {
    onDrop(item.index, index);
  };
  return (
    <div
      className={
        hovered ? `${styles.dropTarget} ${styles.hovered}` : styles.dropTarget
      }
      ref={dropRef}
    >
      <div
        onClick={onClick}
        className={selected ? `${styles.card} ${styles.selected}` : styles.card}
        style={{ opacity: dragging ? 0.4 : 1 }}
        ref={dragRef}
      >
        <MdDragHandle className={styles.cardIcon} />
        <div style={{ flexGrow: 1, marginLeft: 12 }}>{utility.displayName}</div>
        <MdChevronRight className={styles.cardIcon} />
      </div>
    </div>
  );
}
